export const comCopy = {
  com_layout_title: "Jak zacząć pracę z TypeScriptem", // FIXME: Is this the right title for the community page?
  com_layout_description:
    "Poznaj innych użytkowników i użytkowniczki TypeScriptu online i na żywo.",
  com_headline: "Poznajmy się", // FIXME: I think this is not used anywhere
  com_connect_online: "Online",
  com_connect_online_description:
    "Powiedz nam, co działa dobrze, co powinno być dodane lub ulepszone, i dowiedz się o nowych aktualizacjach.",
  com_online_stack_overflow_desc:
    "Zapytaj o poradę swoich kolegów i koleżanki, używając taga 'typescript'",
  com_online_stack_overflow_tag: "",
  com_online_discord_header: "Czat",
  com_online_discord_desc:
    "Porozmawiaj z innymi użytkowni(cz)kami TypeScriptu na Czacie Społeczności.",
  com_online_github_desc:
    "Znalazłeś/aś buga, albo chcesz przekazać nam konstruktywną opinię?",
  com_online_github_href: "Powiedz nam na GitHubie",
  com_online_twitter_desc: "Bądź na bieżąco. Śledź nas na Twitterze",
  com_online_blog_desc:
    "Dowiedz się o najnowszych osiągnięciach w języku TypeScript, czytając nasz ", // ... blog
  com_online_typed_desc: "Pliki definicji TypeScript.",
  com_online_typed_href: "Przeglądaj tysiące",
  com_online_typed_available_for:
    "plików dostępnych dla popularnych bibliotek i frameworków",
  com_person: "Poznaj osobiście",
  com_conferences: "Konferencje",
  com_conferences_alt_img: "logo ",


}
